import { Injectable } from '@angular/core';


/**
 * Translated statuses
 */
@Injectable()
export class ValidationErrorTranslations {
  public i18nRequired: string = $localize`:@@general.validation.required:This field is required`;

  public i18nAtLeast: string = $localize`:@@general.validation.atLeast:Requires at least`;

  public i18nCannotExceed: string = $localize`:@@general.validation.cannotExceed:Cannot exceed`;

  public i18nMinimumValue: string = $localize`:@@general.validation.minimumValue:Minimum value is`;

  public i18nMaximumValue: string = $localize`:@@general.validation.maximumValue:Maximum value is`;

  public i18nCharacters: string = $localize`:@@general.validation.characters:characters`;

  public i18nPattern: string = $localize`:@@general.validation.notRequiredPattern:Form value does not match the required pattern`;

  public i18nIbanNotValid: string = $localize`:@@general.validation.requiredIBAN:Please enter a valid IBAN`;

  public i18nBicNotValid: string = $localize`:@@general.validation.requiredBIC:Please enter a valid BIC`;

  public i18nNoWhitespace: string = $localize`:@@general.validation.whitespaceForbidden:Whitespaces characters are not allowed`;

  public i18nStreetInvalid: string = $localize`:@@general.validation.streetInvalid:Street is not valid. Name and number must be provided with space in between`;

  public i18nEmailNotValid: string = $localize`:@@general.validation.invalidEmail:The email you have entered is not valid`;

  public i18nEmailExists: string = $localize`:@@general.validation.emailExists:The email you have entered already exists`;

  public i18nPasswordIsDifferent: string = $localize`:@@general.validation.passwordDifferent:The password does not match`;

  public i18nPasswordLengthError: string = $localize`:@@general.validation.passwordLengthError:The password must be between 8 and 32 characters long`;

  public i18nPasswordDuplicateError: string = $localize`:@@general.validation.passwordDuplicateError:An identical character may not follow more than twice`;

  public i18nPasswordNotValid: string = $localize`:@@general.validation.passwordNotValid:The password is not valid`;

  public i18nPasswordNotSame: string = $localize`:@@general.validation.passwordNotSame:The passwords do not match`;

  public i18nNumbersOnly: string = $localize`:@@general.validation.numbersOnly:Only numbers allowed`;

  public i18nDateInvalid: string = $localize`:@@general.validation.dateInvalid:Date is invalid`;

  public i18nPastDateInvalid: string = $localize`:@@general.validation.pastDateInvalid:This date should be in the past`;

  public i18nFutureDateInvalid: string = $localize`:@@general.validation.futureDateInvalid:This date should be in the future`;

  public i18nUrlIdInvalid: string = $localize`:@@general.validation.onlyLowercaseAndSpecial:Only lowercase letters, numbers and '-' allowed`;

  public i18nUrlInvalid: string = $localize`:@@general.validation.urlNotValid:The url you provided is not a valid url`;

  public i18nDateRangeIncorrect: string = $localize`:@@general.validation.dateRangeIncorrect:Date range is incorrect`;

  public i18nCustomerNumberNotDifferent: string = $localize`:@@general.validation.customerNumberNotDifferent:The customer numbers should not be the same`;

  constructor() { }

  public required = (error: any): string => this.i18nRequired;

  public minlength = ({ requiredLength, actualLength }: any): string => `${this.i18nAtLeast} ${requiredLength} ${this.i18nCharacters}`;

  public maxlength = ({ requiredLength, actualLength }: any): string => `${this.i18nCannotExceed} ${requiredLength} ${this.i18nCharacters}`;

  public min = ({ min, actual }: any): string => `${this.i18nMinimumValue} ${min}`;

  public max = ({ max, actual }: any): string => `${this.i18nMaximumValue} ${max}`;

  public pattern = ({ requiredPattern, actualValue }: any): string => this.i18nPattern;

  public IBANNotValid = (error: any): string => this.i18nIbanNotValid;

  public BICNotValid = (error: any): string => this.i18nBicNotValid;

  public noWhitespace = (error: any): string => this.i18nNoWhitespace;

  public streetInvalid = (error: any): string => this.i18nStreetInvalid;

  public emailNotValid = (error: any): string => this.i18nEmailNotValid;

  public passwordDifferent = (error: any): string => this.i18nPasswordIsDifferent;

  public passwordLengthError = (error: any): string => this.i18nPasswordLengthError;

  public passwordDuplicateError = (error: any): string => this.i18nPasswordDuplicateError;

  public passwordNotValid = (error: any): string => this.i18nPasswordNotValid;

  public passwordNotSame = (error: any): string => this.i18nPasswordNotSame;

  public emailExists = (error: any): string => this.i18nEmailExists;

  public numbersOnly = (error: any): string => this.i18nNumbersOnly;

  public dateInvalid = (error: any): string => this.i18nDateInvalid;

  public pastDateInvalid = (error: any): string => this.i18nPastDateInvalid;

  public futureDateInvalid = (error: any): string => this.i18nFutureDateInvalid;

  public urlIdInvalid = (error: any): string => this.i18nUrlIdInvalid;

  public urlInvalid = (error: any): string => this.i18nUrlInvalid;

  public dateRangeIncorrect = (error: any): string => this.i18nDateRangeIncorrect;

  public customerNumberNotDifferent = (error: any): string => this.i18nCustomerNumberNotDifferent;

}
